/**
 * Extend given image uuid so we can parse it with the mediaAdapter and use the resulting media
 * FIXME: this is a quick fix we should clean up at some point
 */
export const FakeImageAPI = ({
  id,
  name,
  mars_origin_id,
  mars_shelf_number,
  width,
  height,
}: {
  id: string;
  name: string;
  mars_origin_id?: string;
  mars_shelf_number?: string;
  width?: number;
  height?: number;
}) => {
  return {
    id,
    mars_origin_id,
    mars_shelf_number,
    title: name,
    type: 'image',
    name,
    relationships: {
      image: {
        id,
        meta: {
          alt: name,
          title: name,
          height,
          width,
        },
      },
    },
  };
};

/**
 * Extend given video id, url and poster image so we can parse it with the mediaAdapter and use the resulting media
 * FIXME: this is a quick fix we should clean up at some point
 */
export const FakeVideoAPI = ({
  id,
  url,
  mars_origin_id,
  mars_shelf_number,
  name,
  playingTime,
  mimetype,
  filesize,
  posterImageId,
}: {
  id: string;
  mars_origin_id?: string;
  mars_shelf_number?: string;
  url: string;
  name: string;
  playingTime: number;
  mimetype: string;
  filesize: number | null;
  posterImageId?: string;
}) => {
  return {
    id,
    mars_origin_id,
    mars_shelf_number,
    type: 'video',
    name,
    video: [
      {
        filename: '',
        filemime: mimetype,
        meta: {
          playing_time: playingTime,
        },
        uri: {
          url,
        },
        filesize,
      },
    ],
    poster_image: posterImageId
      ? {
          id: posterImageId,
        }
      : undefined,
  };
};
